import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ShopSearch from '../ShopSearch/ShopSearch';
import ProductCard from '../ProductCard/ProductCard';
import './Shop.css';

const Shop = ({ storeLink }) => {
  return (
    <section className="shop_container">
      <div className="shop_menu">
        <ShopSearch />

        <div className="shop_menu_category">
          <h2>Categories</h2>
          <ul className="shop_menu_items">
            <li>
              <Link to="/trending" className="menu_link">
                Trending
              </Link>
            </li>

            <li>
              <Link to="/discount-sales" className="menu_link">
                Discount Sales
              </Link>
            </li>

            <li>
              <Link to="/newest-arrival" className="menu_link">
                Newest Arrival
              </Link>
            </li>

            <li>
              <Link to="/cart" className="menu_link">
                Cart
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="shop_items">
        <div className="shop_item item_row_1">
          {/* Influencer store category */}
          <div className="shop_item_header">
            <p>Best Seller based on influencers you follow</p>

            <p>
              <Link to={storeLink} className="menu_link">
                View Store
              </Link>
            </p>
          </div>

          <div className="product_container">
            <ProductCard />
          </div>

          {/* Branc store category */}
          <div className="shop_item_header mt-3">
            <p>Best Seller based on Brands you follow</p>

            <p>
              <Link to={storeLink} className="menu_link">
                View Store
              </Link>
            </p>
          </div>

          <div className="product_container">
            <ProductCard />
          </div>

          {/* Newest Arrival */}
          <div className="shop_item_header mt-3">
            <p>Newest Arrival from nike brand</p>

            <p>
              <Link to={storeLink} className="menu_link">
                View Store
              </Link>
            </p>
          </div>

          <div className="product_container">
            <ProductCard />
          </div>

          {/* Suggested products */}
          <div className="shop_item_header mt-3">
            <p>Suggested for you, new brand</p>

            <p>
              <Link to={storeLink} className="menu_link">
                View Store
              </Link>
            </p>
          </div>

          <div className="product_container">
            <ProductCard />
          </div>
        </div>
      </div>
    </section>
  );
};

Shop.propTypes = {
  storeLink: PropTypes.string,
};

Shop.defaultProps = {
  storeLink: '/store',
};

export default Shop;
